<template>
  <section class="ugc-tile-control">
    <ugc-crop-box
      :fabric-canvas="this.fabricCanvas"
      :temp-crop-data="this.tempCropData"
      :lock-square="this.lockSquare"
      :image-format="this.imageFormat"
      ref="cropbox"
    />
    <p class="ugc-tile-control-text">
      {{ $store.state.utils.configuration.enableNewUgcModal ? translations.ugcTileControlDesc2 : translations.ugcTileControlDesc }}
    </p>
  </section>
</template>

<script>
/**
 * TileControl component
 */

import { fabric } from "@vfdp-customs/customs-fabric";

import BaseUgcTool from "../BaseUgcTool";
import ugcCropBox from '@/components/UGC/Tools/CropBox';
import tileConfig from "./tile.json";
import canvasUtils from "@/plugins/canvas/CanvasUtils";

export default {
  name: "UgcTileControl",
  extends: BaseUgcTool,
  components: {
    ugcCropBox
  },
  data() {
    return {
      controlName: "tile",
      lockSquare: true
    };
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    fabricCanvas() {
      return this.$store.state.ugc.stateManager.canvas;
    },
    activeUGCIndex() {
      return this.$store.state.ugc.tempData.activeUGCIndex;
    },
    tempCropData() {
      const { cropper, activeUGCComponent } = this.$store.state.ugc.tempData.features[this.activeUGCIndex];
      return cropper[activeUGCComponent]
        ? cropper[activeUGCComponent][this.controlName]
        : null;
    },
    imageFormat() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex].ugc_image_format;
    }
  },
  methods: {
    /**
     * @function createTile
     * @param imageUrl - base64 image string
     * Creates a tiled image and sets it in the canvas
     */
    createTile(imageUrl) {
      const { width, height, rows, columns } = tileConfig;

      // Load image string
      return canvasUtils
        .getImageFromUrl(imageUrl)
        .then(image => {
          return canvasUtils.resizeImage({ image, width, height });
        })
        .then(imageBuffer => {
          let canvas = canvasUtils.createCanvasElement({ width: columns * width, height: rows * height });
          const ctx = canvas.getContext("2d");
          // Create tile matrix
          for (let x = 0; x < columns; x++) {
            const left = x * width;
            for (let y = 0; y < rows; y++) {
              const top = y * height;
              ctx.drawImage(imageBuffer, left, top); //draw image
            }
          }
          const tiledImage = canvas.toDataURL();
          canvas = null;
          return tiledImage;
        })
        .then(tiledImage => {
          // Set image in canvas
          return this.$store.dispatch("ugc/SET_CANVAS_IMAGE", {
            fabricCanvas: this.fabricCanvas,
            imageSrc: tiledImage
          });
        })
        .then(fabricImage => {
          this.$eventBus.$emit("reload-placement-guide");
          this.$eventBus.$emit("control-finish", this.controlName);
          this.$store.commit("ugc/stateManager/APPLY_TILE_OR_POPART", true);
          return Promise.resolve(fabricImage);
        });
    },
    /**
     * Handler for the cancel button. It hides the cropbox and restores the previous applied image
     * @public
     */
     onControlCancelBack() {
      if (this.tempCropData) {
        const canvasImage = this.fabricCanvas.getObjects("image");
        this.$refs.cropbox.loadImageMetadata({
          image: canvasImage[0],
          data: this.currentImage
        });
      }
      this.$refs.cropbox.hide();
    },
    /**
     * Handler for the done button. It crops the canvas image and fires the tile logic
     * @public
     */
    onControlDone() {
      const { tempData } = this.$store.state.ugc;
      const {
        activeUGCComponent: componentName
      } = tempData.features[tempData.activeUGCIndex];
      const canvasImage = this.fabricCanvas.getObjects("image");
      this.$store.commit("ugc/tempData/SAVE_CROPPER_STATE", {
        tool: this.controlName,
        componentName,
        image: this.$refs.cropbox.getImageMetadata(canvasImage[0]),
        cropBox: {
          height: this.$refs.cropbox.cropBox.height,
          left: this.$refs.cropbox.cropBox.left,
          top: this.$refs.cropbox.cropBox.top,
          width: this.$refs.cropbox.cropBox.width
        }
      });
      const croppedImage = this.$refs.cropbox.crop();
      this.$refs.cropbox.hide();
      this.createTile(croppedImage);
    }
  }
};
</script>
